import { useEffect, useState } from "react";

export default function FloatingActions() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-none transition-all duration-300 hover:bg-primary-600 cursor-pointer ${
          show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line w-5 h-5 flex items-center justify-center"></i>
      </button>
    </div>
  );
}